



















/** @format */

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import toTree, { ITreeNode, getLastLevelNodes } from '@root/utils/to-tree';
import { keyBy, cloneDeep } from 'lodash';
import { Resource, ResourceTree, ResourceType } from '@root/types/resource';

@Component
export default class PermissionSetting extends Vue {
  @Prop()
  checkedKeys!: string[] | null;

  // 选中叶子节点集合（tree组件使用）
  resourceIdList: string[] = [];
  // 所有叶子节点集合（叶子节点+半选的父级，后端使用）
  allSelectedResourceIdList: string[] = [];

  @Getter('user/resourcesTree')
  allResourse!: ITreeNode<ResourceTree>[];

  get allResourseWithIcon() {
    //console.log('?????????????//', JSON.parse(JSON.stringify(this.allResourse)))
    return this.allResourseSetIcon(this.allResourse);
  }

  mounted() {
    this.resourceIdList = this.getSelectedResourceIdList(this.checkedKeys || []);
  }

  @Watch('checkedKeys', { deep: true })
  onChangeCheckedKeys(newVal: string[]) {
    this.resourceIdList = this.getSelectedResourceIdList(newVal || []);
  }

  /**
   * 资源权限树状图勾选变更监听，获取所有勾选子项和其父级，后端需要
   */
  onChangeResourceTree(selectedKeys: any, event: any) {
    this.allSelectedResourceIdList = selectedKeys.concat(event.halfCheckedKeys);
    this.resourceIdList = selectedKeys;
    this.$emit('check', this.allSelectedResourceIdList);
  }

  /**
   * 对比过滤多余父id，整合符合tree组件的叶子节点已选项
   */
  getSelectedResourceIdList(resourceIdList: string[]) {
    // 获取所有权限的叶子节点
    const allLastNodes = getLastLevelNodes(this.allResourse);
    let resourceIdListToTree = [];
    for (var i in resourceIdList) {
      for (var k in allLastNodes) {
        if (allLastNodes[k].id === resourceIdList[i]) {
          resourceIdListToTree.push(allLastNodes[k].id);
        }
      }
    }
    return resourceIdListToTree;
  }

  /**
   * 树状数据所有权限增加icon
   */
  allResourseSetIcon(data: ITreeNode<ResourceTree>[], level = -1) {
    level++;
    const dataClone = cloneDeep(data);
    const iconList = ['app', 'menu1', 'menu2', 'button'];
    dataClone.forEach(item => {
      item.slots = {
        icon: iconList[level]
      };
      item.icon = '';
      if (item.children && item.children.length > 0) {
        item.children = this.allResourseSetIcon(item.children, level);
      }
    });
    return dataClone;
  }
}
